// import Vue from 'vue';
//import { createApp, configureCompat } from 'vue';
import { createApp } from 'vue';
import { configureCompat} from '@vue/compat';
import App from './App.vue';
import router from './router';
import store from './store';

// import VueRouter from 'vue-router';
import 'aab-ui-components/dist/core.css';
import i18n from './i18n';
import 'bootstrap' ;
import 'bootstrap/scss/bootstrap.scss';
// import vuetify from "./plugins/vuetify";
// import sinon from 'sinon';
import '@aab/sc-aab-button';
import '@aab/sc-aab-modal';
import '@aab/sc-aab-info-popover';
import '@aab/sc-aab-notification';
import moment from "moment";
import 'iframe-resizer/js/iframeResizer.contentWindow';

require("./style/abnapp.css");
const script = document.createElement('script');
    script.src = 'https://www.abnamro.nl/nl/retail/pr/static/aab-vendor/analytics/deq/aab-analytics-body.js';
    document.body.append(script);
   // const script2 = document.createElement('script');
    // script2.src = 'https://slimwonen.abnamro.nl/iframeResizer.contentWindow-3.3.5.min.js';
    // document.body.append(script2);

// Vue.config.productionTip = false

// Vue.use(Vuelidate);
// Vue.use(VueRouter);
// document.body.setAttribute('data-app', true);
// initialise({
//   i18n,
// });
createApp(App)
  .use(i18n)
  .use(store)
  .use(router)
  .use(configureCompat)
  // .use(vuetify)
  // .use(simon)
  .use(moment)
  .mount('#app');

